<template>
    <Main>
        <div class="data-steps__title">
            <h3>{{ $t('settingField.label') }}</h3>
        </div>
        <box-loading v-if="isLoading"></box-loading>
        <div v-else class="table-sm table-kb">
            <table id="basicExample" class="table custom-table table-hover table-common">
                <thead>
                    <tr>
                        <th scope="col" class="padding_4">{{ $t('settingField.fieldId') }}</th>
                        <th scope="col" class="padding_4">{{ $t('settingField.title') }}</th>
                        <th scope="col" class="padding_4">{{ $t('settingField.dataType') }}</th>
                        <th scope="col" class="padding_4"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="objectSetting.length === 0" class="disabled-hover">
                        <td class="disabled-border">
                            <Button classes="btn-xs px-2 mr-2 mr-sm-0" type="info" @click="addObject(0)">
                                <el-icon class="el-icon-plus"></el-icon>
                                {{ $t('button.add') }}
                            </Button>
                        </td>
                    </tr>
                    <template v-for="(item, k) in objectSetting">
                        <tr :key="k">
                            <td :data-title="'Field ID'">
                                <InputText
                                    v-model="item.field_id"
                                    :classes="item.error_field_id ? 'input-field__input--error' : ''"
                                    @blur.native="onValidate('field_id', item)"
                                    @keyup.native="onValidate('field_id', item)"
                                ></InputText>
                                <div class="invalid-feedback error-show-common d-block" v-if="item.error_field_id">{{ item.error_field_id }}<i class="el-icon-warning el-icon-undefined"></i></div>
                            </td>
                            <td :data-title="'Field Name'">
                                <InputText
                                    v-model="item.field_name"
                                    :classes="item.error_field_name ? 'input-field__input--error' : ''"
                                    @blur.native="onValidate('field_name', item)"
                                    @keyup.native="onValidate('field_name', item)"
                                ></InputText>
                                <div class="invalid-feedback error-show-common d-block" v-if="item.error_field_name">{{ item.error_field_name }}<i class="el-icon-warning el-icon-undefined"></i></div>
                            </td>
                            <td :data-title="'Field Type'">
                                <div :class="{ 'bg-error': item.error_field_type }">
                                    <SelectCustom classes="w-100" :filterable="false" v-model="item.field_type" @change="onValidate('field_type', item)">
                                        <template #options>
                                            <el-option v-for="(value, index) in typeSettingMember" :value="value.value" :label="value.label" :key="index + 'field_setting'">
                                                {{ value.label }}
                                            </el-option>
                                        </template>
                                    </SelectCustom>
                                </div>
                                <div class="invalid-feedback error-show-common d-block" v-if="item.error_field_type">{{ item.error_field_type }}<i class="el-icon-warning el-icon-undefined"></i></div>
                            </td>
                            <td :data-title="''" class="col-action text-sm-center text-left">
                                <div class="d-flex justify-content-around flex-wrap">
                                    <Button class="btn btn-info btn-xs px-2 mr-2 mr-sm-0" type="info" @click="addObject(k)">
                                        <el-icon class="el-icon-plus"></el-icon>
                                        {{ $t('button.add') }}
                                    </Button>
                                    <Button class="btn btn-danger btn-xs px-2 mr-2 mr-sm-0" type="danger" @click="removeObject(k)">
                                        <el-icon class="el-icon-delete"></el-icon>
                                        {{ $t('button.delete') }}
                                    </Button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <template v-if="!isLoading" #bottomAction>
            <Button type="primary" class="btn btn-primary" @click="resign">
                {{ $t('button.register') }}
            </Button>
        </template>
    </Main>
</template>

<script>
import Main from '@/components/partials/layout/Main';
import InputText from '@/components/partials/customs/InputText';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import { TYPE_SETTING_MEMBER } from '@/config/constants';
import BoxLoading from '@/components/partials/BoxLoading';
import { validMaxLength, validRequired } from '@/utils';

export default {
    name: 'Setting',
    components: {
        Main,
        InputText,
        SelectCustom,
        BoxLoading
    },
    data() {
        return {
            isLoading: false,
            typeSettingMember: TYPE_SETTING_MEMBER,
            objectSetting: []
        };
    },
    computed: {},
    methods: {
        initObject(data = null) {
            let object = {
                field_id: '',
                error_field_id: '',
                field_name: '',
                error_field_name: '',
                field_type: '',
                error_field_type: ''
            };
            if (!data) {
                object = {
                    ...object
                };
            } else {
                object = {
                    ...object,
                    field_id: data.field_id,
                    field_name: data.field_name,
                    field_type: data.field_type
                };
            }
            return object;
        },
        addObject(index) {
            this.objectSetting.splice(index + 1, 0, this.initObject());
        },
        removeObject(index) {
            this.objectSetting.splice(index, 1);
        },
        onValidate(field, item) {
            let check = true;

            if (field === 'field_id') {
                if (!validRequired(item.field_id)) {
                    item.error_field_id = this.$t('text.notEmptyInput', {
                        field: this.$t('settingField.fieldId')
                    });
                    check = false;
                } else if (!validMaxLength(item.field_id, 100)) {
                    item.error_field_id = this.$t('text.max100', {
                        field: this.$t('settingField.fieldId')
                    });
                    check = false;
                } else {
                    item.error_field_id = '';
                }
            }

            if (field === 'field_name') {
                if (!validRequired(item.field_name)) {
                    item.error_field_name = this.$t('text.notEmptyInput', {
                        field: this.$t('settingField.title')
                    });
                    check = false;
                } else if (!validMaxLength(item.field_name, 255)) {
                    item.error_field_name = this.$t('text.max255', {
                        field: this.$t('settingField.title')
                    });
                    check = false;
                } else {
                    item.error_field_name = '';
                }
            }

            if (field === 'field_type') {
                if (!validRequired(item.field_type)) {
                    item.error_field_type = this.$t('text.notEmptyInput', {
                        field: this.$t('settingField.dataType')
                    });
                    check = false;
                } else {
                    item.error_field_type = '';
                }
            }

            if (!field) {
                this.objectSetting.forEach((value) => {
                    if (!validRequired(value.field_id)) {
                        value.error_field_id = this.$t('text.notEmptyInput', {
                            field: this.$t('settingField.fieldId')
                        });
                        check = false;
                    } else if (!validMaxLength(value.field_id, 100)) {
                        value.error_field_id = this.$t('text.max100', {
                            field: this.$t('settingField.fieldId')
                        });
                        check = false;
                    } else {
                        value.error_field_id = '';
                    }
                    if (!validRequired(value.field_name)) {
                        value.error_field_name = this.$t('text.notEmptyInput', {
                            field: this.$t('settingField.title')
                        });
                        check = false;
                    } else if (!validMaxLength(value.field_name, 255)) {
                        value.error_field_name = this.$t('text.max255', {
                            field: this.$t('settingField.title')
                        });
                        check = false;
                    } else {
                        value.error_field_name = '';
                    }
                    if (!validRequired(value.field_type)) {
                        value.error_field_type = this.$t('text.notEmptyInput', {
                            field: this.$t('settingField.dataType')
                        });
                        check = false;
                    } else {
                        value.error_field_type = '';
                    }
                });
            }

            return check;
        },
        getField() {
            this.isLoading = true;
            let successCallback = (response) => {
                let data = response.data.data.setting;
                data.forEach((item) => {
                    this.objectSetting.push(this.initObject(item));
                });
                this.isLoading = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let payload = {
                successCallback,
                errorCallback
            };
            this.$store.dispatch('settingField/detail', payload);
        },
        mapData(object) {
            return object.map((item) => ({
                field_id: item.field_id,
                field_name: item.field_name,
                field_type: item.field_type
            }));
        },
        resign() {
            let check = this.onValidate();
            if (check) {
                if (this.isLoading) return;
                this.isLoading = true;
                let successCallback = () => {
                    this.$store.commit('noticeSystem/SET_MESSAGE', {
                        isShowMessage: true,
                        type: 'success',
                        message: this.$t('text.resignSuccess')
                    });
                    this.isLoading = false;
                };
                let errorCallback = () => {
                    this.isLoading = false;
                };
                let payload = {
                    data: {
                        setting: this.mapData(this.objectSetting)
                    },
                    successCallback,
                    errorCallback
                };
                this.$store.dispatch('settingField/create', payload);
            }
        }
    },
    mounted() {
        this.getField();
    }
};
</script>

<style lang="scss" scoped>
.padding_4 {
    padding: 0.4rem !important;
}

.disabled-border {
    border: unset !important;
}

.disabled-hover:hover {
    background-color: unset !important;
}
</style>
